import { CommentManager } from 'Guide/FrameModules/comments';
import { SettingsCookie } from 'Shared/utils';
import { useState } from 'react';

function openStepComments(stepContainer: HTMLElement) {
   const expandingContainer = stepContainer.querySelector('.comments-container') as HTMLElement;
   const manager = getCommentManager(stepContainer);

   if (!expandingContainer) {
      return;
   }

   manager.loadComments().then(() => {
      expandingContainer.style.height = 'auto';
      expandingContainer.style.opacity = '1';
      expandingContainer.classList.remove('closed');
   });
}

function closeStepComments(stepContainer: HTMLElement) {
   const expandingContainer = stepContainer.querySelector('.comments-container') as HTMLElement;

   if (!expandingContainer) {
      return;
   }

   expandingContainer.classList.add('closed');
   expandingContainer.style.height = '0';
   expandingContainer.style.opacity = '0';
}

function getCommentManager(stepContainer: HTMLElement) {
   const commentContainer = stepContainer.querySelector('.js-comment-container') as any;
   // https://mootools.net/core/docs/1.5.1/Element/Element#Element:retrieve
   let manager = commentContainer.retrieve('commentManager');
   if (!manager) {
      manager = new CommentManager(commentContainer);
      commentContainer.store('commentManager', manager);
   }
   return manager;
}

function getAllStepsWithComments() {
   const steps = Array.from(document.querySelectorAll('.js-step')) as HTMLElement[];
   const stepWithComments = steps.filter(function (item: HTMLElement) {
      const commentEl = item.querySelector('button.js-comment-count');
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      const numComments = Number(commentEl.attributes.getNamedItem('data-numcomments').value);
      return numComments > 0;
   });
   return stepWithComments;
}

function expandAllComments() {
   SettingsCookie.set('expand-comments', 'true');
   getAllStepsWithComments().forEach(openStepComments);
}

function collapseAllComments() {
   SettingsCookie.set('expand-comments', 'false');
   getAllStepsWithComments().forEach(closeStepComments);
}

function useExpandCollapseComments(): [boolean, () => void] {
   const [isExpanded, setExpandComments] = useState(
      SettingsCookie.get('expand-comments') === 'true'
   );

   function toggleExpandComments() {
      if (isExpanded) {
         collapseAllComments();
      } else {
         expandAllComments();
      }
      setExpandComments(!isExpanded);
   }

   return [isExpanded, toggleExpandComments];
}

export { useExpandCollapseComments };
